import { render, staticRenderFns } from "./movieList.vue?vue&type=template&id=052814e0&scoped=true&lang=pug&"
import script from "./movieList.vue?vue&type=script&lang=js&"
export * from "./movieList.vue?vue&type=script&lang=js&"
import style0 from "./movieList.vue?vue&type=style&index=0&id=052814e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052814e0",
  null
  
)

export default component.exports